class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();

    this.addEventListener('change', this.onVariantChange);
  }
  
  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    this.toggleAddButton(true, "", false);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return; // Stop execution if false
    }

    this.deoPdpsellingPlanPicker = document.querySelector('selling-plan-picker[deo-pdp-product-selling-plan-picker]');

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    // To reset the badges in the variant picker
    this.resetVariantBadges();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    const event = new CustomEvent(`${this.dataset.section}-variant:change`, { detail: this.currentVariant});
    document.dispatchEvent(event);

    if (this.deoPdpsellingPlanPicker) {
      this.deoPdpsellingPlanPicker.dataset.currentVariant = JSON.stringify(this.currentVariant);
      
      // Dispatch the event that selling-plan-picker is listening for
      document.dispatchEvent(new CustomEvent(`${this.deoPdpsellingPlanPicker.dataset.sectionId}-variant:change`, {
        detail: this.currentVariant
      }));
    }
      
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest(".main-product");
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(
      this.querySelectorAll("fieldset input:checked")
    )
      .map((element) => element.dataset.optionValueId)
      .join(",");
    params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        productElement.innerHTML =
          html.querySelector(".main-product").innerHTML;
        window.history.replaceState({}, "", `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    const sectionId = this.dataset.section;
    const mediaGridySlider = document.getElementById(`slider-${sectionId}`);
    const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${sectionId}`);

    if (!mediaGridySlider) return;

    if (!this.currentVariant) {
      mediaGridySlider.removeAttribute('data-init-scroll-to');
      mediaGridySlider.querySelectorAll('.product-media').forEach((item, index) => {
        item.style.display = 'block';
      });

      mediaGridySlider.reset();

      return;
    }

    const featuredMediaId = this.currentVariant.featured_media?.id;
    const variantId = this.currentVariant.id;

    mediaGridySlider.querySelectorAll('.product-media').forEach((item, index) => {
      const mediaId = parseInt(item.getAttribute('data-media-id'));
      const isFeaturedMedia = mediaId === featuredMediaId;
      const isVariantMedia =
        item.hasAttribute('data-variant-id') && parseInt(item.getAttribute('data-variant-id')) === variantId;
      item.style.display = isFeaturedMedia || isVariantMedia ? 'block' : 'none';
    });

    mediaGridySlider.reset(false);

    thumbnailsGridySlider?.querySelectorAll('[data-thumbnail-btn]').forEach((item, index) => {
      const mediaId = parseInt(item.getAttribute('data-media-id'));
      const isFeaturedMedia = mediaId === featuredMediaId;
      const isVariantMedia =
        item.hasAttribute('data-variant-id') && parseInt(item.getAttribute('data-variant-id')) === variantId;
      item.style.display = isFeaturedMedia || isVariantMedia ? 'block' : 'none';
    });

    mediaGridySlider.reset(false);

    if (featuredMediaId) {
      mediaGridySlider.scrollToSlideByID(`item-${featuredMediaId}`);
    }

    if (thumbnailsGridySlider && featuredMediaId) {
      thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${featuredMediaId}`);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="items[0]id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector(
      "[data-product-inventory]"
    );

    if (
      !this.productInventoryNode ||
      !window.inventories ||
      !window.inventories[this.dataset.productId]
    )
      return;

    this.inventoryThreshold = parseInt(
      this.productInventoryNode.dataset.threshold
    );
    this.showQuantityInStock =
      this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject =
      window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === "shopify") {
      if (
        variantInventoryObject.quantity <= 0 &&
        variantInventoryObject.incoming === "true" &&
        variantInventoryObject.quantity < this.inventoryThreshold
      ) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(
          true,
          variantInventoryObject.next_incoming_date
        );
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add("hide");
      return;
    }

    this.productInventoryNode.classList.remove(
      "inventory-status--in-stock",
      "inventory-status--low",
      "inventory-status--sold-out",
      "inventory-status--sold-out-continue-selling"
    );

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) <= parseInt(this.inventoryThreshold) &&
      parseInt(quantity) > 0
    ) {
      this.productInventoryNode.classList.add("inventory-status--low");
      if (this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) > parseInt(this.inventoryThreshold)
    ) {
      this.productInventoryNode.classList.add("inventory-status--in-stock");
      if (this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) < 1
    ) {
      this.productInventoryNode.classList.add(
        "inventory-status--sold-out-continue-selling"
      );
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add("inventory-status--sold-out");
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove("hide");
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector(
      "[data-incoming-inventory]"
    );
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add("hide");

      return;
    }

    let string = !date
      ? window.variantStrings.inventory.waiting_for_stock
      : window.variantStrings.inventory.will_be_in_stock_after.replace(
          "[date]",
          date
        );

    incomingInventoryNode.classList.remove("hide");
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const hasOneTimeProduct = this.getAttribute('data-has-one-time-product') === 'true';
  
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : (() => {
              const sectionId = this.dataset.section || "";
              const idx = sectionId.lastIndexOf("-");
              return idx > -1 ? sectionId.slice(0, idx) : sectionId;
            })()
      }`
    )
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const updateContent = (sourceSelector, destinationSelector) => {
        const source = html.querySelector(sourceSelector);
        const destination = document.querySelector(destinationSelector);

        if (source && destination) {
          if (destination.innerHTML !== source.innerHTML) {
            destination.innerHTML = source.innerHTML;
          }
          destination.classList.toggle("hidden", source.classList.contains("hidden"));
        }
      };

      const updateContentAndVisibility = (sourceSelector, destinationSelector) => {
        const source = html.querySelector(sourceSelector);
        const destination = document.querySelector(destinationSelector);

        if (source && destination) {
          if (destination.innerHTML !== source.innerHTML) {
            destination.innerHTML = source.innerHTML;
          }
          destination.style.display = destination.innerHTML.trim() ? '' : 'none';
        }
      };

      const updateBadges = (badges, badgesDestinations) => {
        badges.forEach((badge, index) => {
          const destination = badgesDestinations[index];
          if (destination && badge) {
            destination.innerHTML = badge.innerHTML;
          }
        });
      };

      // Update price only if the product does not have a one-time product option
      if (!hasOneTimeProduct) {
        updateContent(`#price-${this.dataset.section}`, `#price-${this.dataset.section}`);
      }

      updateContent(`#buy-bar-info-${this.dataset.section}`, `#buy-bar-info-${this.dataset.section}`);
      updateContent(`#Sku-${this.dataset.section}`, `#Sku-${this.dataset.section}`);
      updateContent('.main-product [data-variant-description]', '.main-product [data-variant-description]');
      updateContent('.main-product [data-variant-key-notes]', '.main-product [data-variant-key-notes]');
      updateContent('.main-product [data-product-sibling]', '.main-product [data-product-sibling]');
      updateContent('.main-product [data-variant-all-ingredients]', '.main-product [data-variant-all-ingredients]');

      /* Update prices on different places Dec 15 2025
      * 1. Update product price on its own price
      * 2. Update price on Add to bag price with product price from the price section
      * 3. Update price on subscription box from the product price section
      * 4. Update one time box price from the product one time input field
      */
      updateContent('.product-form[deo-pdp-extra-product] .add-to-cart-container', '.product-form[deo-pdp-extra-product] .add-to-cart-container');
      updateContent('.product-form[deo-pdp-extra-product] [data-refill-variant-id]', '.product-form[deo-pdp-extra-product] [data-refill-variant-id]');
      updateContent('.main-product .product-block__limited_edition_info', '.main-product .product-block__limited_edition_info');
      updateContent('.price .price__regular [data-product-price-dynamic]', '.main-product [data-selling-plan-price]');
      updateContent('.main-product [data-selling-plan-price-one-time]', '.main-product [data-selling-plan-price-one-time]');
      if (this.deoPdpsellingPlanPicker && this.deoPdpsellingPlanPicker.querySelector('.selling-plan-picker__option.--one-time')?.classList?.contains('active')) {
        updateContent('.main-product [data-selling-plan-price-one-time] .price-amount', '.add-to-cart-with-price[data-product-price-dynamic] .product-price');
      }
      // Deo PDP main slider and its vertical thumbnails updates
      updateContent('.main-product #deo-pdp-main-slider', '.main-product #deo-pdp-main-slider');
      updateContent('.main-product .gallery-thumbs-slider', '.main-product .gallery-thumbs-slider');

      /* globally DEO pdp slider called */
      setTimeout(() => {
        if (window.initProductGallerySliders) {
          window.initProductGallerySliders();
        }
      }, 50);


      const badges = html.querySelectorAll('.main-product [data-badges]');
      const badgesDestinations = document.querySelectorAll('.main-product [data-badges]');

      const newBadges = html.querySelectorAll('.main-product [data-badgenew]');
      const newBadgesDestinations = document.querySelectorAll('.main-product [data-badgenew]');

      updateBadges(badges, badgesDestinations);
      updateBadges(newBadges, newBadgesDestinations);

      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );

      // Re-attach event listeners after update
      const drawerButton = document.querySelector('a[href="#drawer-extra-product"]');
      if (drawerButton) {
        drawerButton.addEventListener('click', (e) => {
          e.preventDefault();
          Woolman.ModalsAndDrawers.showModalOrDrawer('drawer-extra-product');
        });
      }
    });

    // re-init swiper after DOM update
    setTimeout(() => {
      if (window.initProductGallerySliders) {
        window.initProductGallerySliders();
      }
    }, 50);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const klaviyoButton = productForm.querySelector('.klaviyo-bis-trigger');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      addButton.style.display = 'none';
      if (klaviyoButton) klaviyoButton.style.display = '';
    } else {
      addButton.removeAttribute("disabled");
      if (this.dataset.isPreorder == "true") {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else if (this.dataset.isFreeTrial == "true") {
        addButtonText.textContent = window.variantStrings.freeTrial;
      }
      else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      addButton.style.display = '';
      if (klaviyoButton) klaviyoButton.style.display = 'none';
    }

    const productBuyBar = document.querySelector('product-buy-bar');

    if (productBuyBar) {
      const addButton_BuyBar = productBuyBar.querySelector('button[name="add"]');
      const addButtonText_BuyBar = productBuyBar.querySelector('button[name="add"] > span');
      const klaviyoButton_BuyBar = productBuyBar.querySelector('.klaviyo-bis-trigger');

      if (disable) {
        if (addButton_BuyBar) {
          addButton_BuyBar.setAttribute("disabled", "disabled");
          if (text) addButtonText_BuyBar.textContent = text;
          addButton_BuyBar.style.display = 'none';
        }
        if (klaviyoButton_BuyBar) klaviyoButton_BuyBar.style.display = '';
      } else {
        if (addButton_BuyBar) {
          addButton_BuyBar.removeAttribute("disabled");

          if (this.dataset.isPreorder == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
          } else if (this.dataset.isFreeTrial == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.freeTrial;
          } else if (this.dataset.hasSellingPlan == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.selectFrequency;
          } else {
            addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
          }
          addButton_BuyBar.style.display = '';
        }
        if (klaviyoButton_BuyBar) klaviyoButton_BuyBar.style.display = 'none';
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector("legend [data-variant-legend]");
      const selectedOption = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute("value");
    });
  }

  // Function : resetVariantBadges - To reset the badges in the variant picker
  resetVariantBadges() {
    const newBadges = document.querySelectorAll('.variant-picker [data-badges]');
    newBadges.forEach(badge => {
      badge.innerHTML = "";
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();
    
    this.classes = {
      show: "show",
      observed: "is-observed"
    };

    this.mainProductForm = document.querySelector(".main-product .product-form form");
    this.scrollToElement = document.querySelector(".main-product selling-plan-picker") || document.querySelector(".main-product .product-block__variant_picker") || document.querySelector(".main-product product-form");

    if (!this.mainProductForm) {
      return;
    }

    this.mainProductFormButton = document.querySelector(".main-product .product-form button[type='submit']");

    this.hasSellingPlan = this.getAttribute("has-selling-plan") === "true";
    this.triggerButton = this.querySelector('button');
    
    this.init();
  }
  
  init() {    
    this.triggerButton.addEventListener('click', this.handleClick.bind(this));

    if (!this.hasSellingPlan) {
      document.addEventListener('ajaxProduct:added', () => {
        this.triggerButton.classList.remove('loading');
        this.triggerButton.querySelector('.loading-overlay')?.classList.add('hidden');

        // --- Added animation effect ---
        const span = this.triggerButton.querySelector('span') || this.triggerButton;
        const originalText = span?.innerText || '';

        span.innerText = window.variantStrings.added;

        setTimeout(() => {
          span.innerText = originalText;
        }, 2500);
      });
    }

    this.setupIntersectionObserver();
    this.setupFooterObserver();
  }

  handleClick() {
    if (this.hasSellingPlan) {
      this.scrollToElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      this.mainProductFormButton.click();
      this.triggerButton.classList.add('loading');
      this.triggerButton.querySelector('.loading-overlay')?.classList.remove('hidden');
    }
  }
  
  setupIntersectionObserver() {
    const observerOptions = {
      threshold: 0.25,
      rootMargin: "0px"
    };
    
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), observerOptions);
    this.observer.observe(this.mainProductForm);
  }
  
  handleIntersection(entries) {
    const anyIntersecting = entries.some(entry => entry.isIntersecting);
  
    if (anyIntersecting) {
      this.classList.remove(this.classes.show);
    } else if (window.scrollY > this.mainProductForm.offsetTop) {
      this.classList.add(this.classes.show);
    }
  }
  
  setupFooterObserver() {
    // Use once: true to ensure this only runs once
    document.addEventListener("DOMContentLoaded", () => {
      const siteFooter = document.querySelector("footer.footer");
      
      if (!siteFooter) {
        console.warn("Footer not found - footer observation skipped");
        return;
      }
      
      this.observer.observe(siteFooter);
      siteFooter.classList.add(this.classes.observed);
    }, { once: true });
  }
  
  // Cleanup when element is removed from DOM
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Define the custom element
if (!customElements.get('product-buy-bar')) {
  customElements.define("product-buy-bar", ProductBuyBar);
}
